module.exports = __webpack_public_path__ + "static/media/OctetLogoBlack.315a4909.png";